export default "__VITE_ASSET__BZ8Kq0Ai__"